import axios from 'axios';
import { API_BASE_URL } from '../../config/api';

const BASE = `${API_BASE_URL}/api/paper-builder`;

export const headers = (user) => ({
  'x-user-role': user?.role || '',
  'x-user-name': encodeURIComponent(user?.name || ''),
  'x-user-id': String(user?._id || user?.id || '')
});

export const errMsg = (e) => e?.response?.data?.error || e?.message || 'Something went wrong';

export const getScope = (u) => axios.get(`${BASE}/scope`, { headers: headers(u) }).then((r) => r.data);
export const getStatus = (u) => axios.get(`${BASE}/status`, { headers: headers(u) }).then((r) => r.data);
export const getMasterHeader = (u) => axios.get(`${BASE}/master-header`, { headers: headers(u) }).then((r) => r.data);
export const saveMasterHeader = (u, h) => axios.put(`${BASE}/master-header`, h, { headers: headers(u) }).then((r) => r.data);

export const listPapers = (u, params = {}) => axios.get(`${BASE}/papers`, { headers: headers(u), params }).then((r) => r.data);
export const getPaper = (u, id) => axios.get(`${BASE}/papers/${id}`, { headers: headers(u) }).then((r) => r.data);
export const createPaper = (u, body) => axios.post(`${BASE}/papers`, body, { headers: headers(u) }).then((r) => r.data);
export const updatePaper = (u, id, body) => axios.put(`${BASE}/papers/${id}`, body, { headers: headers(u) }).then((r) => r.data);
export const setPaperStatus = (u, id, body) => axios.patch(`${BASE}/papers/${id}/status`, body, { headers: headers(u) }).then((r) => r.data);
export const deletePaper = (u, id) => axios.delete(`${BASE}/papers/${id}`, { headers: headers(u) }).then((r) => r.data);

export const regenerateQuestion = (u, body) =>
  axios.post(`${BASE}/regenerate-question`, body, { headers: headers(u), timeout: 120000 }).then((r) => r.data);

// Streams NDJSON from /generate with fetch; calls onEvent for every parsed line.
export async function streamGenerate(u, body, onEvent) {
  const res = await fetch(`${BASE}/generate`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', ...headers(u) }, body: JSON.stringify(body)
  });
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try { msg = (await res.json()).error || msg; } catch { /* keep default */ }
    throw new Error(msg);
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = '';
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split('\n');
    buf = parts.pop();
    parts.filter(Boolean).forEach((l) => { try { onEvent(JSON.parse(l)); } catch { /* skip bad line */ } });
  }
  if (buf.trim()) { try { onEvent(JSON.parse(buf)); } catch { /* ignore */ } }
}
